module.exports = __webpack_public_path__ + "static/media/dev-8.0060a9e5.png";